import React from 'react';
import { Wrapper, Text, Button, Emoji } from './elements';

type Props = {
  readonly text: string;
  readonly onClick: (value: number) => void;
  readonly className?: string;
  readonly selected?: number;
};

function FeedbackFooter({
  text,
  onClick,
  className,
  selected,
}: Props): React.ReactElement {
  return (
    <Wrapper className={className}>
      <Text>{text}</Text>
      <Button
        color={selected === 1 ? '#F9FBE7' : '#F4F7F9'}
        hoverColor={'#F9FBE7'}
        onClick={() => onClick(1)}
      >
        <Emoji fontSize={'24px'} symbol={'👍'} label={'Thumbs up'} />
      </Button>
      <Button
        color={selected === -1 ? '#FCDBD7' : '#F4F7F9'}
        hoverColor={'#FCDBD7'}
        onClick={() => onClick(-1)}
      >
        <Emoji fontSize={'24px'} symbol={'👎'} label={'Thumbs down'} />
      </Button>
    </Wrapper>
  );
}

export default FeedbackFooter;
